import { createService } from '@betty/toolkit/api';
import { CategoriesResponseSchema } from '../shared/categories.schemas';

export default {
  ...createService(
    {
      getCategories: {
        method: 'GET',
        url: '/lobby/categories',
        headers: {
          'x-api-version': '2',
        },
        responseSchema: CategoriesResponseSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getPublicCategories: {
      method: 'GET',
      url: '/lobby/categories',
      headers: {
        'x-api-version': '2',
      },
      public: true,
      responseSchema: CategoriesResponseSchema,
    },
  }),
};
